<template>
  <div :class="customClass">
    <order-card title="服务信息">
      <div class="customer-info">
        <div class="userinfo">
          <div>{{ customer }} {{ tel }}</div>
        </div>

        <!-- 预约时间隐藏 -->
        <!-- <div class="appointment" v-if="false">
            <div class="title">预约时间：<span style="color: #787878">{{ appointmentTime() }} {{ detail.serviceStartTime }} - {{ detail.serviceEndTime}}</span></div>
          </div> -->
        <div class="address-div" v-if="detail.contactAddress">
          <div class="title">
            {{ ["FL60000001"].includes(serviceType) ? "联系地址" : "服务起点" }}
          </div>
          <div class="fromeaddress">{{ detail.contactAddress }}</div>
        </div>
       
        <div
          class="address-div"
          v-if="detail.destAddress && ['FL10000002', 'FL70000002', 'FL10000007', 'FL60000004', 'FL70000003'].includes(productType)"
        >
          <div class="title">服务终点</div>
          <div class="toaddress">{{ detail.destAddress }}</div>
        </div>
      </div>
    </order-card>
  </div>
</template>

<script>
import OrderCard from "./order-card.vue";

export default {
  components: {
    OrderCard,
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
    serviceType: {
      type: String,
      default: "",
    },
    customer: {
      type: String,
      default: "",
    },
    tel: {
      type: String,
      default: "",
    },
    productType: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default: new Object(),
    },
  },
  watch: {
    detail: function (val) {
      this.detail = val;
    },
  },
  methods: {
    appointmentTime() {
      if (this.detail.serviceDate) {
        let date = new Date(`${this.detail.serviceDate}`).getDay();
        let day = " 周" + ["一", "二", "三", "四", "五", "六", "日"][date];
        return this.detail.serviceDate + day;
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-info {
  flex-direction: column;
  align-items: flex-start;
  font-size: 15px;

  .userinfo {
    background: url(~@/assets/img/icon_name.png) no-repeat;
    background-size: 8px 8px;
    background-position: 0 center;
    padding-left: 14px;
    color: #333333;
    margin-top: 5px;
    word-break: break-all;
  }

  .toaddress,
  .fromeaddress {
    color: #999999;
    margin-top: 7px;
    margin-left: 14px;
    word-break: break-all;
  }

  .address-div {
    display: flex;
    flex-direction: column;
    margin-top: 15px;

    .title {
      background: url(~@/assets/img/icon_position.png) no-repeat;
      background-size: 8px 8px;
      background-position: 0 5px;
      padding-left: 16px;
      color: #333333;
      word-break: break-all;
    }
  }

  .appointment {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
    padding: 15px 0;
    border-bottom: 1px solid #eeeeee;
    border-top: 1px solid #eeeeee;
    color: #383838;
  }
}
</style>
